import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	TestabilityRegistry,
	ChangeDetectorRef,
	OnDestroy
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../../services/global/global.service";
import { Observable, Subscription } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { DMVDataService } from "../../../services/dmv/dmv-data.service";
import { MEGStoreService } from "../../../services/meg/meg-store.service";

import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { DmvRegistrationManual } from "../../../models/dmv/dmvRegistrationManual";
import { DmvRegistration } from "../../../models/dmv/dmvRegistration";
import { Renewal } from "../../../models/dmv/renewal";
import { RenewalItem } from "../../../models/dmv/renewalItem";
import { Address } from "../../../models/dmv/address";
import { RenewalResponse } from "src/app/models/dmv/renewal-response";
import { TransactionIDResponse } from "src/app/models/dmv/transactionID.response";
import { DmvFee } from "../../../models/dmv/dmvFee";
import { PaymentDetails } from "src/app/models/dmv/models";
import { AppUtil } from "../../../utils/app.util";
import { AppConfigUtil } from "../../../utils/app-config.util";
import { Countries } from "src/app/models/dmv/countries";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { DmvRegistrationDuplicate } from "src/app/models/dmv/dmvRegistrationDuplicate";

@Component({
	selector: "app-dmv-review-cart",
	templateUrl: "./dmv-review-cart.component.html",
	styleUrls: ["./dmv-review-cart.component.css"]
})
export class DmvReviewCartWithBillingComponent implements OnInit, OnDestroy {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public dmvDataService: DMVDataService,
		private formBuilder: FormBuilder,
		public megStoreService: MEGStoreService,
		public userStoreService: USERStoreService,
		private cd: ChangeDetectorRef
	) {}

	public isServiceFeeModelOpen: boolean = false;
	public isOpenTerms: boolean = false;
	public errorMessage: string = "";
	public subTotal: number = 0;
	public total: number = 0;
	public convenienceFee: number = 0;
	public megAppFee: number;
	public submitted: boolean = false;
	public termsAndConditionsForm: FormGroup;
	public isPaymentSucess: boolean;
	// public megAppFeeAbsorbed: boolean;
	public isloading: boolean = false;
	public renewalRequest: Renewal = {};
	public agencyConfig: AgencyDmvConfigResponse;
	//public renewalDataSubscriber: Subscription;
	//public transactionIDResponseSubscriber: Subscription;
	public transactionID: string;
	public fundingToken: string;
	public receiptWhatsNextTextMail: string;
	public receiptWhatsNextTextPickup: string;
	public isTryAgainButtonVisible: boolean;
	public mailFee: number;
	public IsmailFee: boolean;
	public countryName: string;
	public countryList: Countries;
	public notifyTo: string;

	ngOnDestroy() {
		this.userStoreService.saveToProfile = null;
	}
	ngOnInit() {
		AppUtil.log("DmvReviewCartWithBillingComponent ngOnInit");
		if (this.globalService.supportKioskPickup) {
			//this.notifyTo;
			if (
				this.dmvStoreService.registrationsInCart.pickupInPerson.email &&
				this.dmvStoreService.registrationsInCart.pickupInPerson.phone
			) {
				this.notifyTo = this.dmvStoreService.agencyConfig.agencyDmvConfig.reviewPageKioskPickupText3
					.replace(
						"*emailAddress*",
						this.dmvStoreService.registrationsInCart.pickupInPerson.email
					)
					.replace(
						"*phoneNumber*",
						this.dmvStoreService.registrationsInCart.pickupInPerson.phone
					);
			} else if (
				this.dmvStoreService.registrationsInCart.pickupInPerson.email
			) {
				this.notifyTo = this.dmvStoreService.agencyConfig.agencyDmvConfig.reviewPageKioskPickupText1.replace(
					"*emailAddress*",
					this.dmvStoreService.registrationsInCart.pickupInPerson.email
				);
			} else {
				this.notifyTo = this.dmvStoreService.agencyConfig.agencyDmvConfig.reviewPageKioskPickupText2.replace(
					"*phoneNumber*",
					this.dmvStoreService.registrationsInCart.pickupInPerson.phone
				);
			}
		}
		this.IsmailFee = false;
		this.mailFee = 0;
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
		) {
			if (
				this.dmvStoreService.agencyConfig.agencyDmvConfig.mailFeeModel ===
					"MAILONLY" &&
				this.dmvStoreService.registrationsInCart.mailingAddress
			) {
				this.IsmailFee = true;
				this.mailFee = 0;
				this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
					DmvRegistrationItem => {
						if (
							DmvRegistrationItem.registration &&
							DmvRegistrationItem.registration.dmvFees
						) {
							DmvRegistrationItem.registration.dmvFees.forEach(dmvFee => {
								if (dmvFee.feeID === 1) {
									this.mailFee = this.mailFee + dmvFee.amount;
								}
							});
						}
					}
				);
			}
		}
		this.isTryAgainButtonVisible = false;
		this.transactionID = null;
		this.convenienceFee = this.dmvStoreService.registrationsInCart.serviceFeeAmount;
		this.isPaymentSucess = this.dmvStoreService.isPaymentSuccess;

		this.receiptWhatsNextTextMail = this.updateText(
			this.dmvStoreService.agencyConfig.agencyDmvConfig.receiptWhatsNextTextMail
		);
		this.receiptWhatsNextTextPickup = this.updateText(
			this.dmvStoreService.agencyConfig.agencyDmvConfig
				.receiptWhatsNextTextPickup
		);

		this.termsAndConditionsForm = this.formBuilder.group({
			termsAndConditions: [false, Validators.required]
		});

		this.dmvStoreService.agencyConfig$
			.subscribe((response: AgencyDmvConfigResponse) => {
				if (response) {
					this.agencyConfig = response;
					this.megAppFee =
						response.agencyDmvConfig &&
						response.agencyDmvConfig.megAppFee &&
						response.agencyDmvConfig.megAppFee.amount
							? response.agencyDmvConfig.megAppFee.amount
							: 0;
					//this.megAppFeeAbsorbed = response.agencyDmvConfig.megAppFee.absorbed;
					this.totalAmount();
					this.setRenewalRequest();
				}
			})
			.unsubscribe();
		// this.megStoreService.configurationsData$.subscribe(response => {
		// 	if (response) {
		// 		this.megAppFee =
		// 			response.megConfig &&
		// 			response.megConfig.megAppFee &&
		// 			response.megConfig.megAppFee.amount
		// 				? response.megConfig.megAppFee.amount
		// 				: 0;
		// 		this.totalAmount();
		// 	}
		// });
		this.megStoreService.configurationsData$.subscribe(data => {
			if (data && data.megConfig) {
				this.countryList = data.megConfig.countries;
			}
		});

		const countries = this.countryList.filter(item => {
			if (
				this.dmvStoreService.registrationsInCart &&
				this.dmvStoreService.registrationsInCart.mailingAddress &&
				this.dmvStoreService.registrationsInCart.mailingAddress.countryCode
			) {
				return (
					item.countryCode ===
					this.dmvStoreService.registrationsInCart.mailingAddress.countryCode
				);
			}
			return false;
		});
		if (countries && countries.length) {
			this.countryName = countries[0].name;
		}
	}

	public updateText(text) {
		AppUtil.log("DmvReviewCartWithBillingComponent updateText", text);
		if (!text) {
			return;
		}
		text = text.replace(
			"*emailAddress*",
			this.dmvStoreService.paymentDetails.fundingToken.billingEmailAddress
		);

		let paymentMethod = "";
		if (
			this.dmvStoreService.paymentDetails.fundingToken.paymentMethod ===
			"Electronic Check"
		) {
			paymentMethod = "account";
		} else {
			paymentMethod = "card";
		}

		text = text.replace("*cardOrBank*", paymentMethod);

		if (
			this.dmvStoreService.registrationsInCart.pickupInPerson &&
			this.dmvStoreService.registrationsInCart.pickupInPerson.pickupLocation
		) {
			const addressObj = this.dmvStoreService.registrationsInCart.pickupInPerson
				.pickupLocation.address;
			const addressStr =
				addressObj.line1 +
				" " +
				(addressObj.line2 ? addressObj.line2 : "") +
				", " +
				addressObj.city +
				", " +
				addressObj.stateCode +
				", " +
				addressObj.postalCode;
			text = text.replace("*pickupAddress*", addressStr);
		}
		window.scrollTo(0, 0);
		return text;
	}
	public get f() {
		return this.termsAndConditionsForm.controls;
	}
	public totalAmount() {
		let total: number = 0;
		if (this.dmvStoreService.registrationsInCart.dmvRegistrations) {
			this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
				(item: DmvRegistration) => {
					total = total + item.registration.totalAmountDue;
				}
			);
		}

		if (this.dmvStoreService.registrationsInCart.dmvRegistrationsManual) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.forEach(
				(item: DmvRegistrationManual) => {
					total = total + item.amount + item.lateFee;
				}
			);
		}
		if (this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.forEach(
				(item: DmvRegistrationDuplicate) => {
					total = total + item.dmvCostData.totalAmountDue;
				}
			);
		}

		if (this.dmvStoreService.registrationsInCart.donation) {
			total += this.dmvStoreService.registrationsInCart.donation.amount;
		}

		this.subTotal = total;
		this.total =
			(this.subTotal ? this.subTotal : 0) +
			(this.convenienceFee ? this.convenienceFee : 0) +
			(this.megAppFee ? this.megAppFee : 0) +
			this.mailFee;
	}

	public formatedDate(dateStr) {
		if (dateStr && dateStr.indexOf("T") > 0) {
			return dateStr.substring(0, dateStr.indexOf("T"));
		} else {
			return dateStr;
		}
	}
	public goBack() {
		const _this = this;
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID &&
			this.userStoreService.getUserProfile().paymentDevices &&
			this.userStoreService.getUserProfile().paymentDevices.length > 0 &&
			this.userStoreService
				.getUserProfile()
				.paymentDevices.filter(function(item) {
					return (
						Number(_this.dmvStoreService.selectedAgencyId) === item.agencyID
					);
				}).length > 0
		) {
			this.router.navigate(["select-payment-method"], {
				skipLocationChange: true
			});
		} else {
			if (
				this.dmvStoreService.agencyConfig.agencyDmvConfig.serviceProviderID ===
				2
			) {
				this.router.navigate(["gsg-payment"], { skipLocationChange: true });
			} else if (
				this.dmvStoreService.agencyConfig.agencyDmvConfig.serviceProviderID ===
				3
			) {
				this.router.navigate(["meg-payment"], {
					skipLocationChange: true
				});
			} else {
				if (
					AppConfigUtil.getProperties() &&
					AppConfigUtil.getProperties().DirectWebComponentAccess &&
					AppConfigUtil.getProperties().DirectWebComponentAccess === true
				) {
					this.router.navigate(["pnp-payment"], { skipLocationChange: true });
				} else {
					this.router.navigate(["payment"], { skipLocationChange: true });
				}
			}
		}
		this.cd.markForCheck();
	}
	public print() {
		window.print();
	}

	public setRenewalRequest() {
		//this.renewalRequest.renewalToken = this.dmvStoreService.registrationsInCart.renewalToken;
		this.renewalRequest.serviceProviderFee = this.dmvStoreService.registrationsInCart.serviceFeeAmount;
		this.renewalRequest.renewalItems = [];
		if (this.dmvStoreService.registrationsInCart.dmvRegistrations) {
			this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
				(item: DmvRegistration) => {
					const renewalItem: RenewalItem = {};
					renewalItem.registrationID = item.registration.registrationID;
					renewalItem.licensePlate = item.registration.licensePlate;
					renewalItem.registrationType = item.registration.registrationType;
					renewalItem.dmvCostData = {};

					if (
						(this.dmvStoreService.agencyConfig.agencyDmvConfig.mailFeeModel ===
							"MAILONLY" &&
							this.dmvStoreService.registrationsInCart.pickupInPerson) ||
						this.dmvStoreService.agencyConfig.agencyDmvConfig.mailFeeModel ===
							"NEVER"
					) {
						let dmvFees = item.registration.dmvFees;
						if (dmvFees) {
							dmvFees = dmvFees.filter(function(fee) {
								return fee.feeID !== 1;
							});
						}
						renewalItem.dmvCostData.dmvFees = dmvFees;
					} else {
						renewalItem.dmvCostData.dmvFees = item.registration.dmvFees;
					}

					renewalItem.dmvCostData.renewalCost = item.registration.renewalCost;
					let mailFeeAmount = 0;

					if (
						this.agencyConfig.agencyDmvConfig.mailFeeModel === "MAILONLY" &&
						this.dmvStoreService.registrationsInCart.mailingAddress
					) {
						item.registration.dmvFees.forEach(dmvFee => {
							if (dmvFee.feeID === 1) {
								mailFeeAmount = mailFeeAmount + dmvFee.amount;
							}
						});
					}

					renewalItem.dmvCostData.totalAmountDue = item.registration
						.totalAmountDue
						? Number(
								(mailFeeAmount + item.registration.totalAmountDue).toFixed(2)
							)
						: mailFeeAmount + item.registration.totalAmountDue;

					renewalItem.renewalOptionID = item.selectedRenewalOption;
					if (item.isPlateChange) {
						renewalItem.newTagCode = item.registration.currentTagCode;
					}
					renewalItem.insuranceData = item.globalInsuranceData;
					this.renewalRequest.renewalItems.push(renewalItem);
				}
			);
		}

		if (this.dmvStoreService.registrationsInCart.dmvRegistrationsManual) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.forEach(
				(item: DmvRegistrationManual) => {
					const renewalItem: RenewalItem = {};
					renewalItem.registrationType = item.vechicleType;
					renewalItem.licensePlate = item.tagNumber;
					renewalItem.expirationDate = item.expirationDate;
					if (
						item.insuranceIdNo &&
						item.insuranceCompany &&
						item.insurancePolicyNo
					) {
						renewalItem.insuranceData = {};
						renewalItem.insuranceData.companyCode = item.insuranceIdNo;
						renewalItem.insuranceData.companyName = item.insuranceCompany;
						renewalItem.insuranceData.policyNumber = item.insurancePolicyNo;
					}

					renewalItem.renewalOptionID = 1;

					renewalItem.dmvCostData = {};
					renewalItem.dmvCostData.totalAmountDue = item.amount + item.lateFee;
					renewalItem.dmvCostData.totalAmountDue = renewalItem.dmvCostData
						.totalAmountDue
						? Number(renewalItem.dmvCostData.totalAmountDue.toFixed(2))
						: renewalItem.dmvCostData.totalAmountDue;

					renewalItem.dmvCostData.renewalCost = item.amount;
					renewalItem.dmvCostData.dmvFees = [];
					const dmvFees: DmvFee = {};
					dmvFees.feeID = 3;
					dmvFees.amount = item.lateFee;
					dmvFees.displaySequence = 1;
					renewalItem.dmvCostData.dmvFees.push(dmvFees);
					this.renewalRequest.renewalItems.push(renewalItem);
				}
			);
		}

		if (this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.forEach(
				(item: DmvRegistrationDuplicate) => {
					const renewalItem: RenewalItem = {};
					renewalItem.registrationType = item.vechicleType;
					renewalItem.licensePlate = item.tagNumber;
					renewalItem.expirationDate = item.expirationDate;

					renewalItem.renewalOptionID = 10;

					renewalItem.dmvCostData = item.dmvCostData;

					this.renewalRequest.renewalItems.push(renewalItem);
				}
			);
		}

		if (this.dmvStoreService.registrationsInCart.donation) {
			this.renewalRequest.donations = [];
			this.renewalRequest.donations.push(
				this.dmvStoreService.registrationsInCart.donation
			);
		} else {
			this.renewalRequest.donations = undefined;
		}
		//	if (this.megAppFee) {
		this.renewalRequest.megAppFee = this.megAppFee;
		//	}
		//this.renewalRequest.megAppFeeAbsorbed = this.megAppFeeAbsorbed;

		if (this.dmvStoreService.registrationsInCart.pickupInPerson) {
			if (this.globalService.supportKioskPickup) {
				this.renewalRequest.pickupLocationID =
					"" +
					this.dmvStoreService.agencyConfig.agencyDmvConfig
						.kioskPickupLocationID;
				if (this.dmvStoreService.registrationsInCart.pickupInPerson.phone) {
					this.renewalRequest.pickupPhoneNumber = this.dmvStoreService.registrationsInCart.pickupInPerson.phone
						.replace(/[^\w\s]/gi, "")
						.replace(/ /g, "");
				}
				if (this.dmvStoreService.registrationsInCart.pickupInPerson.email) {
					this.renewalRequest.pickupEmailAddress = this.dmvStoreService.registrationsInCart.pickupInPerson.email;
				}
			} else {
				this.renewalRequest.pickupLocationID =
					"" +
					this.dmvStoreService.registrationsInCart.pickupInPerson.pickupLocation
						.locationID;
				if (
					this.dmvStoreService.registrationsInCart.pickupInPerson
						.authorizedPerson
				) {
					this.renewalRequest.pickupPersonName = this.dmvStoreService.registrationsInCart.pickupInPerson.authorizedPerson;
				}
			}
			this.renewalRequest.deliveryMethod = "PU";
		}

		if (this.dmvStoreService.registrationsInCart.mailingAddress) {
			const mailToAddress: Address = {};
			this.renewalRequest.mailToName = this.dmvStoreService.registrationsInCart.mailingAddress.registrantName;
			mailToAddress.line1 = this.dmvStoreService.registrationsInCart.mailingAddress.billigAddress1;
			mailToAddress.line2 = this.dmvStoreService.registrationsInCart.mailingAddress.billigAddress2;
			mailToAddress.city = this.dmvStoreService.registrationsInCart.mailingAddress.city;
			mailToAddress.countryCode = this.dmvStoreService.registrationsInCart.mailingAddress.countryCode;
			mailToAddress.postalCode = this.dmvStoreService.registrationsInCart.mailingAddress.zip;
			mailToAddress.stateCode = this.dmvStoreService.registrationsInCart.mailingAddress.state;

			this.renewalRequest.updateAddressOnFile = this.dmvStoreService.registrationsInCart.mailingAddress.updateAddress;
			if (this.dmvStoreService.registrationsInCart.dmvRegistrations) {
				if (
					this.dmvStoreService.registrationsInCart.mailingAddress
						.updateAddressCheckBox ||
					this.dmvStoreService.registrationsInCart.mailingAddress
						.tempAddressChange ||
					this.dmvStoreService.registrationsInCart.mailingAddress
						.permAddressUpdate
				) {
					this.renewalRequest.deliveryMethod = "MX";
					this.renewalRequest.mailToAddress = mailToAddress;
				} else {
					this.renewalRequest.deliveryMethod = "MF";
				}
			} else if (
				this.dmvStoreService.registrationsInCart.dmvRegistrationsManual ||
				this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate
			) {
				this.renewalRequest.deliveryMethod = "MX";
				this.renewalRequest.mailToAddress = mailToAddress;
			}
			if (
				this.dmvStoreService.registrationsInCart.addressComefrom === "manual"
			) {
				this.renewalRequest.deliveryMethod = "MX";
				this.renewalRequest.mailToAddress = mailToAddress;
			}
		}

		this.renewalRequest.fundingToken = this.dmvStoreService.paymentDetails.fundingToken.fundingToken;
		//this.renewalRequest.notificationOptions =
		//this.renewalRequest.comment =

		AppUtil.log(
			"DmvReviewCartWithBillingComponent setRenewalRequest() ===>",
			this.renewalRequest
		);
	}
	public callRenewApi(renewalRequest, agencyID) {
		AppUtil.log(
			"DmvReviewCartWithBillingComponent callRenewApi() ===> request >",
			renewalRequest,
			agencyID
		);
		this.dmvDataService
			.getUpdatedRenewalResponse(
				renewalRequest,
				agencyID,
				this.dmvStoreService.registrationsInCart.renewalToken,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					AppUtil.log(
						"DmvReviewCartWithBillingComponent callRenewApi() ===> response >",
						response
					);
					if (response) {
						this.isloading = true;
						this.dmvStoreService.registrationsInCart.renewalToken =
							response.renewalToken;
						this.callSubmitApi(response.renewalToken, agencyID);
						this.cd.markForCheck();
					}
				},
				error => {
					AppUtil.log(
						"DmvReviewCartWithBillingComponent callRenewApi() ===> error >",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + "	(EC: RNU)";
						this.isloading = false;
						this.isTryAgainButtonVisible = true;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}

	public callSubmitApi(renewalToken, agencyID) {
		AppUtil.log(
			"DmvReviewCartWithBillingComponent callSubmitApi() ===> request >",
			renewalToken,
			agencyID
		);
		this.dmvDataService
			.getRenewalSubmitResponse(
				renewalToken,
				agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					AppUtil.log(
						"DmvReviewCartWithBillingComponent callSubmitApi() ===> response >",
						response
					);
					if (response && response.status) {
						if (
							response.status === 200 &&
							response.headers.get("outcomeCode") &&
							Number(response.headers.get("outcomeCode")) === 0 &&
							response.body &&
							response.body.transactionID
						) {
							this.isloading = false;

							this.transactionID = response.body.transactionID;
							this.dmvStoreService.isPaymentSuccess = true;
							this.isPaymentSucess = true;
							this.dmvStoreService.isPaymentSucess = true;

							window.scrollTo(0, 0);
							this.cd.markForCheck();
						} else {
							this.isTryAgainButtonVisible = true;
							this.errorMessage =
								response.headers.get("outcomeText") ||
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.systemFailureText + " (EC: SUB) ";
							this.isloading = false;
							window.scrollTo(0, 0);
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log(
						"DmvReviewCartWithBillingComponent callSubmitApi() ===> error >",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							error.headers.get("outcomeText") ||
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC: SUB) ";
						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}

	// public getFundingToken(paymentDetails: PaymentDetails, agencyID) {
	// 	this.dmvDataService
	// 		.getFundingTokenResponse(paymentDetails.fundingToken, agencyID)
	// 		.subscribe(
	// 			response => {
	// 				if (response) {
	// 					this.isloading = false;
	// 					this.fundingToken = paymentDetails.fundingToken.fundingToken;
	// 					this.renewalRequest.fundingToken =
	// 						paymentDetails.fundingToken.fundingToken;
	// 					this.callRenewApi(
	// 						this.renewalRequest,
	// 						this.agencyConfig.agencyDmvConfig.agencyID
	// 					);
	// 					// this.dmvStoreService.routeFrom = null;
	// 					// this.dmvStoreService.registrationsInCart = {};
	// 					// this.dmvStoreService.registrationsInCart.firstIteration = true;
	// 					this.cd.markForCheck();
	// 				}
	// 			},
	// 			error => {
	// 				if (error.name ==="TimeoutError" || (error["status"] && error["status"] !== 200)) {
	// 					this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;
	// 					this.isloading = false;
	// 					this.cd.markForCheck();
	// 				}
	// 			}
	// 		);
	// }

	public pay() {
		this.errorMessage = "";
		this.submitted = true;
		if (!this.termsAndConditionsForm.controls.termsAndConditions.value) {
			this.errorMessage =
				"Please review and accept Terms & Conditions before continuing.";
			window.scrollTo(0, 0);
			return;
		}

		this.isloading = true;
		//this.getFundingToken(
		//	this.dmvStoreService.paymentDetails,
		//	this.agencyConfig.agencyDmvConfig.agencyID
		//);

		this.callRenewApi(
			this.renewalRequest,
			this.agencyConfig.agencyDmvConfig.agencyID
		);
	}
	public openTerms() {
		this.isOpenTerms = true;
	}
	public closePopupTerms() {
		this.isOpenTerms = false;
	}

	public openServiceFeeModel() {
		this.isServiceFeeModelOpen = true;
	}
	public closeServiceFeeModel() {
		this.isServiceFeeModelOpen = false;
	}
}
